import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";

// const sleep = () => new Promise((resolve) => setTimeout(resolve, 1000));

// axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;

axios.defaults.baseURL = "https://drnayebzadehapp.ir/api/";

const responseBody = (response: AxiosResponse) => response.data;

axios.interceptors.response.use(
  async (response) => {
    // if (process.env.NODE_ENV === "development") await sleep();
    return response;
  },
  (error: AxiosError) => {
    const { data, status } = error.response as AxiosResponse;
    switch (status) {
      case 400:
        if (data.errors) {
          const modelStateErrors: string[] = [];
          for (const key in data.errors) {
            if (data.errors[key]) {
              modelStateErrors.push(data.errors[key]);
            }
          }
          throw modelStateErrors.flat();
        }
        toast.error(data.title);
        break;
      case 401:
        toast.error(data.title);
        break;
      case 403:
        toast.error("You are not allowed to do that!");
        break;
      case 500:
        // router.navigate("/server-error", { state: { error: data } });
        break;
      default:
        break;
    }

    return Promise.reject(error.response);
  }
);

function createFormData(item: any) {
  let formData = new FormData();
  for (const key in item) {
    formData.append(key, item[key]);
  }
  return formData;
}

const requests = {
  get: (url: string, params?: URLSearchParams) =>
    axios.get(url, { params }).then(responseBody),
  post: (url: string, body: {}) => axios.post(url, body).then(responseBody),
  put: (url: string, body: {}) => axios.put(url, body).then(responseBody),
  delete: (url: string) => axios.delete(url).then(responseBody),
  postForm: (url: string, data: FormData) =>
    axios
      .post(url, data, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody),
  putForm: (url: string, data: FormData) =>
    axios
      .put(url, data, {
        headers: { "Content-type": "multipart/form-data" },
      })
      .then(responseBody),
};

const Slider = {
  TopSlider: () => requests.get("Slider.aspx"),
};

const Catalog = {
  list: (params: URLSearchParams) => requests.get("Product.aspx", params),
  featuredProductsList: () => requests.get("ProductTop.aspx"),
  newProductsList: () => requests.get("ProductNew.aspx"),
  details: (param: URLSearchParams) => requests.get("Product.aspx", param),
  fetchFilters: () => requests.get("products/filters"),
};

const Category = {
  list: () => requests.get("Category.aspx"),
  details: (id: number) => requests.get(`Category.aspx/${id}`),
};

const Brand = {
  list: () => requests.get("Brands"),
  details: (id: number) => requests.get(`Brands/${id}`),
};
const TestErrors = {
  get400Error: () => requests.get("buggy/bad-request"),
  get401Error: () => requests.get("buggy/unauthorised"),
  get404Error: () => requests.get("buggy/not-found"),
  get500Error: () => requests.get("buggy/server-error"),
  getValidationError: () => requests.get("buggy/validation-error"),
};

const Basket = {
  get: () => requests.get("basket"),
  addItem: (productId: number, quantity = 1) =>
    requests.post(`basket?productId=${productId}&quantity=${quantity}`, {}),
  removeItem: (productId: number, quantity = 1) =>
    requests.delete(`basket?productId=${productId}&quantity=${quantity}`),
};

const Account = {
  register: (params: URLSearchParams) =>
    requests.get("LoginRegister.aspx", params),
  login: (params: URLSearchParams) =>
    requests.get("VerifySMSCode.aspx", params),
  setAddress: (params: URLSearchParams) =>
    requests.get("SetAddress.aspx", params),
  getAddress: (params: URLSearchParams) => requests.get("Address.aspx", params),
  currentUser: () => requests.get("account/currentUser"),
  fetchAddress: () => requests.get("account/savedAddress"),
};

const Orders = {
  list: () => requests.get("orders"),
  fetch: (id: number) => requests.get(`orders/${id}`),
  create: (values: any) => requests.post("orders", values),
  registerOrder: (params: URLSearchParams) =>
    requests.get("SetBasket.aspx", params),
  setOrderBill: (params: URLSearchParams) =>
    requests.get("SetFactor.aspx", params),
};

const About = {
  mainText: () => requests.get("AboutUs.aspx"),
  representatives: () => requests.get("branch.aspx"),
};

const ContactUs = {
  contactDetail: () => requests.get("ContactUs.aspx"),
};
const Blog = {
  blogPosts: (params: URLSearchParams) => requests.get("Blog.aspx", params),
  blogPostDetail: (params: URLSearchParams) =>
    requests.get("Blog.aspx", params),
  blogCategories: () => requests.get("BlogCategory.aspx"),
};

const Gallery = {
  list: () => requests.get("Gallery.aspx"),
};

const News = {
  list: () => requests.get("News.aspx"),
};

const Requests = {
  Request: (values: URLSearchParams) => requests.get("SetForm.aspx", values),
};

const Admin = {
  //product
  createProduct: (product: any) =>
    requests.postForm("products", createFormData(product)),
  updateProduct: (product: any) =>
    requests.putForm("products", createFormData(product)),
  deleteProduct: (id: number) => requests.delete(`products/${id}`),
  //category
  createCategory: (category: any) =>
    requests.postForm("Categories", createFormData(category)),
  deleteCategory: (id: number) => requests.delete(`Categories/${id}`),
  //brand
  createBrand: (Brands: any) =>
    requests.postForm("Brands", createFormData(Brands)),
  deleteBrand: (id: number) => requests.delete(`Brands/${id}`),
  //broker
  BrokerList: () => requests.get("Brokers"),
  createBroker: (Brokers: any) =>
    requests.postForm("Brokers", createFormData(Brokers)),
  deleteBroker: (id: number) => requests.delete(`Brokers/${id}`),
  brokerDetails: (id: number) => requests.get(`Brokers/${id}`),
};

const agent = {
  Slider,
  Catalog,
  Category,
  Brand,
  TestErrors,
  Basket,
  Account,
  Orders,
  Admin,
  About,
  ContactUs,
  Blog,
  Gallery,
  News,
  Requests,
};

export default agent;
